import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { CheckboxInterface } from 'common/types/entities/CheckboxInterface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export const createCheckbox = (
  parentId: string,
  defaultText: string,
  masterBlockId?: MasterBlockId,
): CheckboxInterface => {
  return {
    ...generateBaseEntity(EntityTypeEnum.Checkbox, parentId, masterBlockId),
    content: `<p>${defaultText}</p>`,
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    fontSize: 16,
    errorText: 'settings_options.checkbox_message',
    optional: false,
    textAlign: 'left',
  }
}
